import React from 'react';

import PreviewTool from '../components/PreviewTool/PreviewTool';

function PreviewToolPage() {
  return <PreviewTool />;
}

export default PreviewToolPage;
